(() => {
  const STORAGE_KEY = 'andy-selection-localization-v1';
  const MANUAL_KEY = 'andy-selection-localization-manual-v1';
  const MAX_AGE = 30 * 24 * 60 * 60 * 1000;

  const markManualChoice = (event) => {
    const form = event.target?.closest?.("form[action*='/localization']");
    if (!form || form.id === 'AndyAutoLocalizationForm') return;
    try {
      localStorage.setItem(MANUAL_KEY, '1');
    } catch (_) {}
  };

  document.addEventListener('change', markManualChoice, { capture: true });

  const start = async () => {
    if (window.Shopify?.designMode) return;

    const dataElement = document.getElementById('AndyAutoLocalizationData');
    const form = document.getElementById('AndyAutoLocalizationForm');
    if (!dataElement || !form) return;

    let data;
    try {
      data = JSON.parse(dataElement.textContent || '{}');
      if (localStorage.getItem(MANUAL_KEY) === '1') return;
      const handledAt = Number(localStorage.getItem(STORAGE_KEY) || 0);
      if (handledAt && Date.now() - handledAt < MAX_AGE) return;
    } catch (_) {
      return;
    }

    const languages = Array.isArray(data.languages) ? data.languages : [];
    const countries = Array.isArray(data.countries) ? data.countries : [];
    if (!languages.length) return;

    const byPrefix = (prefix) =>
      languages.find((locale) => String(locale).toLowerCase().split('-')[0] === prefix);

    const browserLanguages = Array.isArray(navigator.languages) && navigator.languages.length
      ? navigator.languages
      : [navigator.language];
    let targetLanguage = null;

    for (const preferred of browserLanguages) {
      const normalized = String(preferred || '').toLowerCase();
      targetLanguage = languages.find((locale) => String(locale).toLowerCase() === normalized);
      if (!targetLanguage) targetLanguage = byPrefix(normalized.split('-')[0]);
      if (targetLanguage) break;
    }

    let detectedCountry = null;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}browsing_context_suggestions.json`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (response.ok) {
        const context = await response.json();
        detectedCountry = context?.detected_values?.country?.handle || null;
      }
    } catch (_) {}

    if (!targetLanguage && detectedCountry) {
      const country = String(detectedCountry).toUpperCase();
      const languageByCountry = {
        PT: 'pt', BR: 'pt', AO: 'pt', CV: 'pt', GW: 'pt', MZ: 'pt', ST: 'pt', TL: 'pt',
        FR: 'fr', BE: 'fr', CH: 'fr', LU: 'fr', MC: 'fr',
        DE: 'de', AT: 'de', LI: 'de',
      };
      if (languageByCountry[country]) targetLanguage = byPrefix(languageByCountry[country]);
    }

    targetLanguage ||= data.currentLanguage;
    const targetCountry = countries.includes(detectedCountry) ? detectedCountry : data.currentCountry;
    const countryChanged = targetCountry && targetCountry !== data.currentCountry;
    const languageChanged = targetLanguage && targetLanguage !== data.currentLanguage;

    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (_) {}

    if (!countryChanged && !languageChanged) return;

    const countryInput = form.querySelector("[name='country_code']");
    const languageInput = form.querySelector("[name='language_code']");
    const returnInput = form.querySelector("[name='return_to']");
    if (countryInput && targetCountry) countryInput.value = targetCountry;
    if (languageInput && targetLanguage) languageInput.value = targetLanguage;
    if (returnInput) returnInput.value = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    form.submit();
  };

  start();
})();

